import React from 'react';
import Home from "./Home";
import Connect from './Connect';

const Controll = () => {


    return (
        <>
            <Home />
            <Connect />
        </>
    );
};

export default Controll;